import { NavLink } from 'react-router-dom';
import { Home, CalendarHeart, LayoutList, MessageSquare, User, Baby } from 'lucide-react';
import { cn } from '@/lib/utils';
import { isNative } from '@/lib/capacitor';
import { usePregnancyStore } from '@/store/pregnancyStore';

export function BottomNav() {
  const { appMode } = usePregnancyStore();
  const isBabyMode = appMode === 'baby';

  // Dynamic nav items based on mode
  const navItems = [
    { to: '/', icon: Home },
    { to: isBabyMode ? '/baby' : '/ssw', icon: isBabyMode ? Baby : CalendarHeart },
    { to: '/tools', icon: LayoutList },
    { to: '/chat', icon: MessageSquare },
    { to: '/profile', icon: User },
  ];

  // Native App: Fixed container at bottom with safe area, light glass effect
  if (isNative) {
    return (
      <nav
        className="fixed bottom-0 left-0 right-0 z-50"
        style={{
          // Both iOS and Android: use safe-area-inset for gesture navigation / home indicator
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        }}
      >
        {/* 10px margin above safe area on both platforms for rounded display corners */}
        <div className="mx-4 mb-[10px]">
          <div className="bottom-nav-glass rounded-2xl px-3 py-0">
            <div className="flex items-center justify-around">
              {navItems.map(({ to, icon: Icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  end={to === '/'}
                  className={({ isActive }) =>
                    cn(
                      'p-3 transition-all',
                      isActive && 'rounded-[12px] bg-pp-dark/15'
                    )
                  }
                >
                  {({ isActive }) => (
                    <Icon
                      className={cn(
                        'w-5 h-5 transition-all',
                        isActive ? 'text-pp-dark' : 'text-pp-dark/60'
                      )}
                    />
                  )}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </nav>
    );
  }

  // Web App: Original floating glass design
  return (
    <nav className="fixed bottom-4 left-0 right-0 z-50">
      <div className="max-w-[400px] mx-auto px-6">
        <div className="bottom-nav-glass rounded-2xl px-3 py-0">
          <div className="flex items-center justify-around">
            {navItems.map(({ to, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/'}
                className={({ isActive }) =>
                  cn(
                    'p-3 transition-all',
                    isActive && 'rounded-[12px] bg-pp-dark/10 border border-pp-dark/10'
                  )
                }
              >
                {({ isActive }) => (
                  <Icon
                    className={cn(
                      'w-5 h-5 transition-all',
                      isActive ? 'text-pp-dark' : 'text-pp-dark/60'
                    )}
                  />
                )}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
